import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=d1cfacf2&scoped=true"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=d1cfacf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cfacf2",
  null
  
)

export default component.exports